import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=4a0abfcd&"
import script from "./Approval.vue?vue&type=script&lang=js&"
export * from "./Approval.vue?vue&type=script&lang=js&"
import style0 from "./Approval.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_jh\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0abfcd')) {
      api.createRecord('4a0abfcd', component.options)
    } else {
      api.reload('4a0abfcd', component.options)
    }
    module.hot.accept("./Approval.vue?vue&type=template&id=4a0abfcd&", function () {
      api.rerender('4a0abfcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/soeapproval/components/Approval.vue"
export default component.exports